import React, { useState, useContext, useEffect } from "react";

import "./PAlauncher.css";

import {
  InputCopy,
  FormGroup,
  Select,
  Tooltip,
  StatusDot,
  Checkbox,
  Subheader,
  Button,
  Head,
  Card,
  Input,
  RadioGroup,
  Breadcrumbs,
  Switch,
  Icon,
  ButtonAction,
  Pill,
  Tag,
  Notification
} from "xsolla-uikit";

import PAtabs from './PAtabs';

import CardNew from "./PAcardNew";
import { ContextConsumer } from "../App";
import { Link } from "react-router-dom";
import { IntlProvider } from "react-intl";
import merge from "deepmerge";

import SwitchExample from "./SwitchExample";
import PAContentBlock from "./PAContentBlock";
import LauncherVersions from "./PAlauncherVersions";

export default function PAlauncherProject({
  product = 'launcher',
  sku = 'login_1',
  name = "My Game: Ultimate Edition",
  id = "mygame.xsollasitebuilder.com",
  img = "https://res.cloudinary.com/maiik/image/upload/v1549624607/Xsolla/HomePage_Hero_Illustration_1440_oabqmk.jpg",
  status = "tab",
  customize = 'widget',
}) {
  let [state, setState] = useState({
    twoCols: false,
    tab: "build" //'build', ''banners', 'news'
  });

  const handleLink = () => {
    setState({
      tab: "customization"
    })
  }

  return (

      <div className="xsui-width">


<FormGroup indentation="xs">
      <Breadcrumbs
          //.xsui-breadcrumbs_label {max-width: 100% !important;} //TODO: fix
          items={[
            {
              label: "Launcher",
              to: "/launcher"
            },
            {
              label: (
                <React.Fragment>
                  <div className="l_flex">
                    {name}{" "}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center"
                      }}
                    >
                      <span style={{ margin: "0px 0 0 16px" }}>
                        <Pill
                          appearance={`${
                            status !== "draft" ? `tab` : `warning`
                          } `}
                        >
                          <StatusDot
                            status={`${
                              status !== "draft" ? `enabled` : `testing`
                            } `}
                          >
                            {" "}
                            {status}
                          </StatusDot>
                        </Pill>
                      </span>
                    </div>
                  </div>
                </React.Fragment>
              ),
              to: "/site_builder"
            }
          ]}
        />
        </FormGroup>

        <FormGroup indentation="xlg">
              <PAtabs
                // extra={<Button size="sm" appearance="secondary">Go to Store Builder</Button>}
                tab={state.tab}
                handleTab={nw => {
                  setState({
                    ...state,
                    tab: nw
                  });
                }}
                items={[
                  {
                    name: "News",
                    stateName: "news",
                    icon: "analytics"
                  },
                  {
                    name: "Banners",
                    stateName: "banners",
                    icon: "analytics"
                  },
                  {
                    name: "Customization",
                    stateName: "customization",
                    icon: "tile-view"
                  },
                  {
                    name: "Settings",
                    stateName: "general",
                    icon: "tile-view"
                  },
                  {
                    name: 'Build settings',
                    stateName: 'build',
                    icon: "redo"
                  },
                  // {
                  //   name: "Refund policy",
                  //   stateName: "refund",
                  //   icon: "exclamation-alert"
                  // }
                ]}
              />

        </FormGroup>


        <div className="xsui-content-block xsui-content-block--appearance-primary xsui-form-group--indentation-lg">






          {state.tab === "customization" && (
            <FormGroup indentation="lg">
              <PAContentBlock title="Version" border="lg">
                {/* <FormGroup border="lg"> */}
                <FormGroup>

                  <Notification status="info">
                    <div style={{width: '100%'}}>
                <Select
                  disabled={false}
                  name="Select version to customize:"
                  options={[
                    {label: `Published version`, description: 'Last changes: 28 May 2019 12:00', value: "0"},
                    {label: `Visual edits`, description: 'Last changes: 30 May 2019 12:00', value: "1"},
                  ]}
                  searchable={false}
                  autosize={false}
                  size="md"
                  input={{
                    name: 'test',
                    value: "0",
                    // onChange: change
                  }}
                />
                </div>
                </Notification>

                </FormGroup>
          </PAContentBlock>
          <PAContentBlock title="Customization" border="lg">
                {/* <FormGroup border="lg"> */}
                <FormGroup label="" tooltip="">
                  </FormGroup></PAContentBlock>
          </FormGroup>)}


          {state.tab === "build" && (
            <FormGroup indentation="lg">
              <PAContentBlock title="Builds" border={false}>
                <FormGroup indentation="lg">
                  <LauncherVersions handleLink={handleLink} />
                </FormGroup>
              </PAContentBlock>
            </FormGroup>
          )}

          {state.tab === "general" && (
            <FormGroup indentation="lg">
              <PAContentBlock title="General Settings" border="lg">
                {/* <FormGroup border="lg"> */}
                <FormGroup label="ID" tooltip="This domain is set by default">
                  <div style={{ display: "flex" }}>
                    <div
                      style={{
                        display: "block",
                        width: "100%",
                        marginRight: 8
                      }}
                    >
                      <div
                        style={{
                          position: "relative",
                          width: "100%",
                          display: "block"
                        }}
                      >
                        <input
                          name="external_id"
                          disabled
                          className="xsui-input xsui-input--size-md xsui-input--appearance-primary"
                          type="text"
                          data-id="external_id"
                          data-value="30c2d7dd-2f0d-4d0c-b0db-d31c79d8028d"
                          defaultValue="30c2d7dd-2f0d-4d0c-b0db-d31c79d8028d"
                        />
                      </div>
                    </div>
                    <div className="xsui-tooltip">
                      <div
                        className
                        data-tooltipped
                        aria-describedby="tippy-tooltip-400"
                        data-original-title="undefined"
                        style={{ display: "inline" }}
                      >
                        <button
                          className="xsui-button xsui-button--appearance-square xsui-button--size-md"
                          type="button"
                          style={{ flexShrink: 0 }}
                        >
                          <i
                            className="xsui-icon xsui-icon-copy"
                            style={{ fontSize: 24, color: "inherit" }}
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </FormGroup>

                <FormGroup
                  label="Launcher name"
                  tooltip="This domain is set by default"
                >
                  <Input
                    input={{
                      // name: 'with-icon',
                      value: "mikatest"
                    }}
                    offset="right"
                    extra={
                      <Icon
                        name="edit"
                        hoverable={true}
                        // onClick={e => this.handeCurrDel(this.id, e)}
                      />
                    }
                  />
                </FormGroup>

                <FormGroup
                  label="Languages"
                  tooltip="This domain is set by default"
                >
                  <div class="lang-select__button lang-select__button--selected">
                    English
                  </div>
                  <div class="lang-select__button">Russian</div>
                  <Button appearance="flatten">
                    Add more languages...
                    {/* <Icon name="arrow" /> */}
                  </Button>
                </FormGroup>
                {/* </FormGroup> */}
              </PAContentBlock>
              <PAContentBlock title="Launcher Authentication" border="lg">
                {/* <FormGroup border="lg"> */}
                <FormGroup indentation="md">
                  <FormGroup
                    label="Select Login"
                    tooltip="Login Tip"
                    indentation="sm"
                  >
                    <div className="ui-radio-content ui-radio-content_selected">
                      <div className="">
                        <div className="xsui-radio__wrapper">
                          <label data-value="ce084f8d-89bf-11e8-ad67-d89d67155224">
                            <input
                              readOnly
                              className="xsui-radio__input"
                              type="radio"
                              checked
                              defaultValue="ce084f8d-89bf-11e8-ad67-d89d67155224"
                            />

                            <div className="xsui-radio__label">
                              Test BNK Launcher
                            </div>
                            <div
                              className="ui-mike-sku"
                              style={{ paddingLeft: 24 }}
                            >
                              ID: ce084f8d-89bf-11e8-ad67-d89d67155224
                            </div>
                          </label>
                        </div>
                      </div>
                    </div>
                  </FormGroup>
                  <FormGroup indentation="sm">
                    <Button appearance="flatten" icon="add">
                      New Login
                    </Button>
                  </FormGroup>
                </FormGroup>
                {/* </FormGroup> */}
              </PAContentBlock>

              {/* <PAContentBlock title="Project Setup" border="lg">
              <FormGroup>
                <div className="ui-table">

                  <div className="ui-table__body">

                        <div className="ui-table__column ui-table__column--indentation-md">
                          <div className="games-container__project-info">
                            <div className="games-container__project-info__content">
                              <div className="games-container__project-info__content__id">
                                ID 43892
                              </div>
                              <div className="games-container__project-info__content__name">
                                mikatest-may-8-1
                              </div>
                            </div>
                          </div>
                        </div>


                        <div
                          className="ui-table__column ui-table__column--indentation-md"
                          style={{ flexShrink: 0, width: "auto" }}
                        >
                          <div className="games-container__project-actions">
                            <a
                              aria-current="false"
                              href="/59320/projects/43892/launchers/30c2d7dd-2f0d-4d0c-b0db-d31c79d8028d/games/1790/builds-setup"
                            >
                              <button
                                className="xsui-button xsui-button--appearance-flatten xsui-button--size-md"
                                type="button"
                              >
                                <i
                                  className="xsui-icon xsui-icon-build"
                                  style={{ fontSize: 24, color: "inherit" }}
                                />
                                Build settings
                              </button>
                            </a>
                            <div className="games-container__project-actions__separator" />
                            <a
                              aria-current="false"
                              href="/59320/projects/43892/launchers/30c2d7dd-2f0d-4d0c-b0db-d31c79d8028d/games/1790"
                            >
                              <button
                                className="xsui-button xsui-button--appearance-flatten xsui-button--size-md"
                                type="button"
                              >
                                <i
                                  className="xsui-icon xsui-icon-module"
                                  style={{ fontSize: 24, color: "inherit" }}
                                />
                                Project modules
                              </button>
                            </a>
                          </div>
                        </div>
                        <div
                          className="ui-table__column ui-table__column--indentation-md"
                          style={{ flexShrink: 0, width: 48 }}
                        >
                          <span />
                        </div>
                      </div>
                    </div>

              </FormGroup>
            </PAContentBlock> */}

              <PAContentBlock title="Social" border={false}>
                <FormGroup>
                  <SwitchExample value={false} label="Friends">
                    Allow players to find, make friends, and chat with other
                    users.
                  </SwitchExample>
                </FormGroup>
              </PAContentBlock>

              <PAContentBlock title="Game Keys" border="lg">
                <FormGroup>
                  <SwitchExample value={false} label="Activation with a key">
                    Users will be able to enter a key to activate a game
                  </SwitchExample>
                </FormGroup>
              </PAContentBlock>
            </FormGroup>
          )}

          {state.tab === "general" && <FormGroup indentation="lg" />}
        </div>
      </div>

  );
}
